  <div class="modal-content" style="width: 135%;height: 112%">
    <div class="modal-header" >
      <button type="button" class="close" aria-label="Close" (click)="closeBSF()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title" translate>CONTRACT_LINK_MODAL_INVOICES_MANAGEMENT
        <span *ngIf="!selectedOneItem && selectedItem?.length" translate>({{selectedItem?.length}} selected subscriptions)</span></h4>
    </div>
    <div class="modal-body">
      <div class="portlet-body">
           <span *ngIf="selectedOneItem ; else multiItems">
          <storever-header-subtitle [datas]="[
           {icon: 'fa-users', title: 'GENERIC_CLIENT', name: selectedOneItem.clientName},
           {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: selectedOneItem?.name},
           {icon: 'fal fa-box', title: 'GENERIC_PRODUCT', name: selectedOneItem.productName},
           {icon: 'fa-shipping-fast fal', title: 'GENERIC_DELIVERY_DATE', name: selectedOneItem?.deliveryDate | date: 'dd/MM/yyyy'}]"></storever-header-subtitle>
      </span>
        <ng-template #multiItems >
<!--          <div class="help-block error" *ngIf="!checkProductType()" translate>SUBSCRIPTION_SELECTED_WITH_DIFFERENT_PRODUCT</div>-->
          <div [ngClass]="selectedItem?.length > 6 ? 'scroll' : null" >
          <span *ngFor="let item of selectedItem let i = index " >
          <storever-header-subtitle [isAllowedRemove]="true" [datas]="[
           {icon: 'fa-users', title: 'GENERIC_CLIENT', name: item.clientName},
           {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: item?.name},
           {icon: 'fal fa-box', title: 'GENERIC_PRODUCT', name: item.productName},
           {icon: 'fa-shipping-fast fal', title: 'GENERIC_DELIVERY_DATE', name: item?.deliveryDate | date: 'dd/MM/yyyy' }]">
           <i class="fal fa-trash-alt" *ngIf="selectedItem?.length > 1" style="margin-top:6px" tooltip="{{ 'DELETE' | translate:locale.language}}" (click)="removeSubscription(i)"></i>
          </storever-header-subtitle>
      </span>
          </div>
        </ng-template >
        <br>
        <alert type="info">
          <div style="padding-bottom: 6px;">
            <span><strong><i class="fas fa-info-square"></i></strong></span>
            <span><strong> Clear invoices :</strong>{{'INVOICES_MANAGEMENT_HELP_1' | translate:locale.language}}</span><br><br>
            <span><strong> Use periodic : </strong>{{'INVOICES_MANAGEMENT_HELP_2' | translate:locale.language}}</span><br>
          </div>
        </alert><br>
        <form [formGroup]="myForm" style="width:100%" class="link_box">
          <storever-element-group
            [icon]="'fa-address-book'"
            [title]="'none'"
            [config]="formConfig.config"
            [form]="myForm">
          </storever-element-group>
        </form>
        <br>
<!--        <span *ngIf="!isAnomalies">-->
<!--          <div class="space-title"  translate>CONTRACT_MODAL_SELECTED_SUBSCRIPTIONS</div>-->
<!--          <div class="help-block error" *ngIf="error !== 'false'">{{error}}</div>-->
<!--          </span>-->
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" [disabled]="!myForm.dirty"
              id="CONTRACT_LINK_MODAL_LINK"   (click)="send(myForm.value)"> {{'SAVE' | translate:locale.language}} </button>
      <button type="button" class="btn btn-default" (click)="closeBSF()">{{'CANCEL' | translate:locale.language}}</button>
    </div>
  </div>

